module.exports = __webpack_public_path__ + "img/gq0.5e6e0130.png";